import React, { ReactNode } from 'react';
import { isAdvancedUser } from 'src/common/session/SessionService';
import { Role } from './Role';

interface Props {
    fallback?: ReactNode;
}

export const AdvancedUserRole: React.FC<Props> = ({ children, fallback }) => (
    <Role isRole={isAdvancedUser} fallback={fallback}>
        {children}
    </Role>
);
